import { render, staticRenderFns } from "./CapillariesTemplate.vue?vue&type=template&id=762f0c0e"
import script from "./CapillariesTemplate.vue?vue&type=script&lang=js"
export * from "./CapillariesTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports